/* eslint-disable max-len */
import React from 'react';

var IconCert = function IconCert() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "21",
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.12533H11.82C11.4 0.916992 10.3 0.0419922 9 0.0419922C7.7 0.0419922 6.6 0.916992 6.18 2.12533H2C0.9 2.12533 0 3.06283 0 4.20866V18.792C0 19.9378 0.9 20.8753 2 20.8753H16C17.1 20.8753 18 19.9378 18 18.792V4.20866C18 3.06283 17.1 2.12533 16 2.12533ZM9 2.12533C9.55 2.12533 10 2.59408 10 3.16699C10 3.73991 9.55 4.20866 9 4.20866C8.45 4.20866 8 3.73991 8 3.16699C8 2.59408 8.45 2.12533 9 2.12533ZM11 16.7087H4V14.6253H11V16.7087ZM14 12.542H4V10.4587H14V12.542ZM14 8.37533H4V6.29199H14V8.37533Z",
    fill: "#444749"
  }));
};

export default IconCert;